import { FunctionComponent, useCallback, useEffect } from 'react';
import { StepContainer } from '../StepContainer';
import { useCheckoutContext } from '../CheckoutContext';
import { Login } from '../../Login';
import Redirect from '../../../pages_components/login/Services/Redirect';

export type LoginStepProps = {};

export const LoginStep: FunctionComponent<LoginStepProps> = () => {
    const { course, checkoutState, submitResponse } = useCheckoutContext();

    useEffect(() => {
        Redirect.init(new URL(window.location.href));
    }, []);

    const onBackClick = useCallback(() => {
        return submitResponse({
            actionType: 'go back',
            payload: {},
        });
    }, [submitResponse]);

    return (
        <StepContainer
            course={course}
            optimisticCheckoutState={checkoutState}
            onBackClick={onBackClick}
        >
            <Login />
        </StepContainer>
    );
};
